export const initState = () => ({
	form: null,
	optInFanOffer: false,
	formGroups: {
		clubGroup: {
			heading: {
				isDisabled: false
			},
			checkboxes: []
		},
		leagueGroup: {
			heading: {
				isDisabled: false
			},
			checkboxes: [{
				id: 'SOCCEROOS_NEWS_SUB',
				txt: 'Subway Socceroos',
				src: '/images/leagueLogos/newlogos/socceroos.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'MATILDAS_SUB',
				txt: ' CommBank Matildas',
				src: '/images/leagueLogos/newlogos/matildas.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'PARAROOS_SUB',
				txt: 'CommBank Pararoos',
				src: '/images/leagueLogos/newlogos/pararoos.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'PARAMATILDAS_SUB',
				txt: 'CommBank Paramatildas',
				src: '/images/leagueLogos/newlogos/paramatildas.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'FFACUP_SUB',
				txt: 'HAHN Australia Cup',
				src: '/images/leagueLogos/newlogos/auscup.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
                 id: 'AUS_CHAMPS_SUB',
                 txt: 'Australian Championship',
                 src: '/images/leagueLogos/newlogos/AustralianChampionship_resized.png',
                 isChecked: false,
                 isDisabled: false,
                 isShow: true
			}, {
				id: 'NPL_SUB',
				txt: 'National Premier Leagues',
				src: '/images/leagueLogos/newlogos/npl.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'WWCBID_SUB',
				txt: 'Our Game',
				src: '/images/leagueLogos/our_game_117x96.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, //{
				//id: 'NST_SUB',
				//txt: 'National Second Tier',
				//src: '/images/leagueLogos/newlogos/NST_Green.png',
				//isChecked: false,
				//isDisabled: false,
				//isShow: true
				//},
			 {
				id: '2026WAC_SUB',
				txt: '2026 AFC Women’s Asian Cup',
				src: '/images/leagueLogos/newlogos/asiacup.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'AL_MEN_SUB',
				txt: 'ISUZU UTE A-League Men',
				src: '/images/leagueLogos/newlogos/aleague_men.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'AL_WOMEN_SUB',
				txt: 'NINJA A-League Women',
				src: '/images/leagueLogos/newlogos/aleague_women.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			},]
		},
		grassrootsGroup: {
			heading: {
				isDisabled: false
			},
			checkboxes: [{
				id: 'FOOTBALL_AUSTRALIA_SUB',
				txt: 'Football Australia',
				src: '/images/grassroots/FAUS_Logo_170x75.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			} , {
				id: 'MINIROOS_NEWS_SUB',
				txt: 'Coles Miniroos',
				src: '/images/leagueLogos/newlogos/miniroos.png',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}]
		},
		priorityTicketing: {
			heading: {
				isDisabled: false
			},
			checkboxes: [{
				id: 'FF_SUB',
				txt: 'Priority Ticketing',
				description: 'Subscribe to priority ticketing alerts to get exclusive discounts and early access to Socceroos, Matildas and more.',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}]
		},
		offerGroup: {
			heading: {
				isDisabled: false
			},
			checkboxes: []
		},
		checkboxGroup: {
			heading: {
				isDisabled: false
			},
			checkboxes: [{
				id: 'Merchandise_NEWS_SUB',
				txt: 'Merchandise & Online Store ',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'FFA_PARTNER_SUB',
				txt: 'Partner Offers',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}]
		},
		disableCommunicationGroup: {
			heading: {
				isDisabled: false
			},
			checkboxes: [{
				id: 'Email_Communication',
				txt: 'I do not wish to receive any email communications and special offers',
				name: 'ffa_donotbulkemail',
				description: 'Opt-out of email communications from Football Australia, you can update this at any time',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}, {
				id: 'Mobile_Communication',
				txt: 'I do not wish to receive any mobile communications and special offers',
				name: 'ffa_donotbulkmobile',
				description: 'Opt-out of mobile communications from Football Australia, you can update this at any time',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}]
		},
		disableGroup: {
			heading: {
				isDisabled: false
			},
			checkboxes: [{
				id: 'ffa_donotbulkemail',
				txt: 'I do not wish to receive any email communications and special offers',
				description: 'Opt-out of communications from Football Australia, you can update this at any time',
				isChecked: false,
				isDisabled: false,
				isShow: true,

				reasoning: [{
					id: 'ffa_unsubscribereason',
					txt: 'Please provide a reason for unsubscribing',
					value: '',
					options: [{
						id: '',
						txt: 'Please select value',
					}, {
						id: 'receive_to_many_emails',
						txt: 'I receive too many emails',
					}, {
						id: 'dont_remember_signing_up',
						txt: 'I don’t remember signing up',
					}, {
						id: 'content_is_not_relevant',
						txt: 'The content is not relevant for me',
					}, {
						id: 'no_longer_a_football_supporter',
						txt: 'I am no longer a football supporter',
					}]
				}, {
					id: 'ffa_unsubscribereasonother',
					txt: 'Any other feedback',
					value: ''
				}]

			}, {
				id: 'ffa_bulkemailfrequency',
				txt: 'I would like to receive less email communications',
				description: 'Change the frequency to two emails per month, you can update this any time',
				isChecked: false,
				isDisabled: false,
				isShow: true
			}]
		},
		optinGroup: {
			heading: {
				isDisabled: false
			},
			checkboxes: [{
				id: 'wwcbid_optin',
				txt: 'I am #Onside for Australia\'s Bid to host the FIFA Women\'s World Cup 2023',
				description: 'Select to be included in the official AsOne2023 supporter count, you can update this anytime',
				isChecked: true,
				isDisabled: false,
				isShow: true
			}]
		},
		// deletePreferences: {
		// 	heading: {
		// 		isDisabled: false
		// 	},
		// 	checkboxes: [{
		// 		id: 'delete_preferences',
		// 		txt: 'Remove Preferences',
		// 		isChecked: false,
		// 		isDisabled: false,
		// 		isShow: true
		// 	}]
		// }
	}
});

export default initState();
